import { createSlice } from "@reduxjs/toolkit";
import {
  fetchWalletListThunk,
  fetchWalletDetailsThunk,
  fetchWalletTransactionsThunk,
  fetchUserWalletDetailsThunk,
} from "../thunk/walletThunk";
import { WalletBasicType, WalletDetailsType, WalletTransactionResponseType } from "../../types/walletTypes";

interface WalletState {
  walletList: WalletBasicType[];
  walletDetails: WalletDetailsType | null;
  walletTransactions: WalletTransactionResponseType | null;
  userWalletDetails: WalletDetailsType | null;
}

const initialState: WalletState = {
  walletList: [],
  walletDetails: null,
  walletTransactions: null,
  userWalletDetails: null
};

const walletReducer = createSlice({
  name: "wallet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchWalletListThunk.fulfilled, (state, action) => {
      state.walletList = action.payload ?? [];
    });
    builder.addCase(fetchWalletDetailsThunk.fulfilled, (state, action) => {
      state.walletDetails = action.payload;
    });
    builder.addCase(fetchUserWalletDetailsThunk.fulfilled, (state, action) => {
      state.userWalletDetails = action.payload;
    });
    builder.addCase(fetchWalletTransactionsThunk.fulfilled, (state, action) => {
      state.walletTransactions = action.payload;
    });
  },
});

export default walletReducer.reducer;